import { CLEAR_NOTES_SEARCH_DATA, NOTES_SEARCH_LOADING, SET_NOTES_SEARCH_DATA } from './types'

const initialState = {
  data: [],
  query: {
    totalRecords: 0,
    limit: 5,
    first: 0,
  },
  isLoading: false,
}

export default function notesSearchReducer(state = initialState, action) {
  switch (action.type) {
    case NOTES_SEARCH_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }
    case SET_NOTES_SEARCH_DATA:
      return {
        ...state,
        data: action.payload?.data || [],
        query: action.payload?.query || initialState.query,
      }
    case CLEAR_NOTES_SEARCH_DATA:
      return {
        ...state,
        data: [],
        query: initialState.query,
      }
    default:
      return state
  }
}
